var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cart
    ? _c(
        "div",
        { staticClass: "cart-overview" },
        [
          _c("dates-overview", {
            attrs: { cart: _vm.cart, "can-edit": _vm.canEdit },
            on: {
              edit: function ($event) {
                return _vm.$emit("edit", $event)
              },
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.cart.lines, function (room, i) {
            return _c("room-overview", {
              key: room.id,
              attrs: {
                "room-index": i,
                cart: _vm.cart,
                "can-edit": _vm.canEdit,
              },
              on: {
                close: function ($event) {
                  return _vm.$emit("close")
                },
              },
            })
          }),
          _vm._v(" "),
          _c("taxes-overview", { attrs: { cart: _vm.cart } }),
          _vm._v(" "),
          !_vm.withoutTotals
            ? _c("total-overview", { staticClass: "box final-total" })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "fine-print" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.tc("cart.myCart.finePrint")) + "\n  "
            ),
          ]),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }